


const File = (props) => {
    
    return <div className="card file pointer" {...props}>

        {props.icon}

        <p>{props.name}</p>

    </div>
}

export default File;